@if (searchResult$ | async; as searchResult) {
  <dcp-search-field></dcp-search-field>

  @if (!!searchResult.products.length) {
    <div class="udex-grid udex-mx-auto">
      <udex-tab-navigation
        size-more-button="Small"
        (click)="onTabClick($event)"
        class="udex-pt-48 heading__bold--l">
        <udex-tab [text]="tabNavItems[0].text"></udex-tab>
        <udex-tab [text]="tabNavItems[1].text" selected></udex-tab>
        <udex-tab [text]="tabNavItems[2].text"></udex-tab>
        <udex-tab [text]="tabNavItems[3].text"></udex-tab>
      </udex-tab-navigation>

      @if (facetSearchService.backendFacets && visibleFacets$ | async) {
        @if (mergedFacets$ | async) {
          <div
            class="d-none d-lg-flex align-items-center"
            data-cy="search-navigation-bar">
            @for (facet of mergedFacets$ | async; track $index) {
              <dcp-facet-filter
                (valueChanged)="toggleFacetValueList(facet, $event)"
                [(scrollPosition)]="facetScrollPosition"
                (scrollPositionChange)="facetScrollPosition.position=0"
                class="udex-pe-32"
                [facet]="facet">
              </dcp-facet-filter>
            }
            @if (model$ | async; as model) {
              <dcp-sorting-dropdown
                (sortListEvent)="sortList($event)"
                [placeholder]="'search.sortBy' | cxTranslate"
                [selectedOption]="(model.pagination && model.pagination.sort) ? model.pagination.sort :  undefined"
                [sortOptions]="model.sorts"
                class="udex-ms-auto">
              </dcp-sorting-dropdown>
            }
          </div>
        }
      }

      <div class="d-flex justify-content-between">
        <dcp-search-sorting></dcp-search-sorting>

        <udex-button
          class="d-lg-none"
          data-cy="search-navigation-bar__more-filters"
          (click)="openNavBar()"
          (keydown.enter)="openNavBar()">{{'search.filterAndSort' | cxTranslate}}
        </udex-button>
      </div>

    </div>
  }

    <dcp-results-list></dcp-results-list>
}
